/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import './style/bluemateTextarea.scss';

import React, {ReactNode, TextareaHTMLAttributes} from 'react';

import {ErrorType} from '@dvrd/dvr-controls';

import classNames from 'classnames';

import {BluemateControlShape, BluemateControlSize} from '../../../util/types';

import InputController from '../input/inputController';

interface Props {
    onChange: (value: string, evt: React.ChangeEvent) => void;
    value: string;
    label?: ReactNode;
    placeholder?: string;
    error?: ErrorType;
    disabled?: boolean;
    autoFocus?: boolean;
    className?: string;
    inputProps?: TextareaHTMLAttributes<any>;
    rows?: number;
    fullWidth?: boolean;
    size?: BluemateControlSize;
    shape?: BluemateControlShape;
    styled?: boolean;
    uniformFont?: boolean;
    id?: string;
}

export default function BluemateTextarea(props: Props) {
    const {rows = 6, shape = 'rounded', className, inputProps, ...rest} = props;

    return (
        <InputController
            {...rest}
            area
            shape={shape}
            className={classNames('bluemate-textarea', className)}
            inputProps={{rows, ...inputProps}}
        />
    );
}
